import {Fragment, useState} from "react";
import {IconButton} from "@mui/material";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import DeleteDialog from "./DeleteDialog";

type Props = {
    domainId: number;
    onSuccess: () => void;
    name: string;
};

export default ({domainId, name, onSuccess}: Props) => {
    const [isDialogOpen, setDialogOpen] = useState(false);

    return (
        <Fragment>
            <IconButton color="secondary" onClick={() => setDialogOpen(true)} size="small">
                <FontAwesomeIcon icon="trash" />
            </IconButton>
            <DeleteDialog
                name={name}
                onSuccess={onSuccess}
                domainId={domainId}
                isOpen={isDialogOpen}
                close={() => setDialogOpen(false)}
            />
        </Fragment>
    );
};
